/**
 * Мелкие настройки приложения в localStorage. Ошибки хранилища (приватный
 * режим, переполнение) глотаются: без него приложение работает, просто
 * не помнит, что уже показывало.
 */
const ONBOARDING_KEY = 'reels.onboarding.v1';

export function readOnboardingSeen(): boolean {
  try {
    return window.localStorage.getItem(ONBOARDING_KEY) === '1';
  } catch {
    return false;
  }
}

export function markOnboardingSeen(): void {
  try {
    window.localStorage.setItem(ONBOARDING_KEY, '1');
  } catch {
    // без хранилища онбординг просто покажется ещё раз
  }
}
